import React from "react";
import styles from "./result.module.css";
import {Page} from "../../components/page/page";
// import {useSelector} from "react-redux";
import {useGenerateOneLink} from "../../../../hooks/useGenerateOneLink";

const ResultPage = () => {
    // const guestId = useSelector((store) => store.guestId);
    // const resultLink = `https://front-dev.zodiaq.vip/horoscopes?userId=${guestId}&source=date-birth`;

    const resultLink = useGenerateOneLink();

    return (
    <Page title="Wow, your horoscope is unusual!" hideSteps="true" nextPageLink={resultLink.clickURL}>
      <p className={styles.text}>Only <span>15%</span> of people have such results!</p>
    </Page>
  );
}

export { ResultPage };
